var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.75C1.75 3.08696 2.01339 2.45107 2.48223 1.98223C2.95107 1.51339 3.58696 1.25 4.25 1.25H21.75C22.413 1.25 23.0489 1.51339 23.5178 1.98223C23.9866 2.45107 24.25 3.08696 24.25 3.75V16.25C24.25 16.913 23.9866 17.5489 23.5178 18.0178C23.0489 18.4866 22.413 18.75 21.75 18.75H4.25C3.58696 18.75 2.95107 18.4866 2.48223 18.0178C2.01339 17.5489 1.75 16.913 1.75 16.25V3.75Z",
    stroke: "#545454",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.75L13 11.25L24.25 3.75",
    stroke: "#545454",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.c9fcb34d56e36d1269e0dbbeb34ac110.svg";
export { ForwardRef as ReactComponent };